import { useContext, useState, useEffect, useRef } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function Step15Legal() {
  const { sessionId, setCurrentStep } = useContext(OnboardingContext);

  const [msaScrolled, setMsaScrolled] = useState(false);
  const [privacyScrolled, setPrivacyScrolled] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const msaRef = useRef(null);
  const privacyRef = useRef(null);

  useEffect(() => {
    const msaBox = msaRef.current;
    const privacyBox = privacyRef.current;

    function checkScroll(ref, setter) {
      const el = ref.current;
      if (!el) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
        setter(true);
      }
    }

    msaBox.addEventListener("scroll", () => checkScroll(msaRef, setMsaScrolled));
    privacyBox.addEventListener("scroll", () =>
      checkScroll(privacyRef, setPrivacyScrolled)
    );
  }, []);

  async function submit() {
    const res = await fetch("/api/admin-onboarding/legal", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        accepted
      })
    });

    const data = await res.json();
    if (data.next_step === "finalize") {
      setCurrentStep("finalize");
    }
  }

  const canAccept = msaScrolled && privacyScrolled;

  return (
    <div>
      <h2>Legal Agreements</h2>
      <p>Please review and acknowledge the CloudGenomics legal documents.</p>

      <h3>Master Subscription Agreement</h3>
      <div
        ref={msaRef}
        style={{
          height: "300px",
          overflowY: "scroll",
          border: "1px solid #ccc",
          padding: "1rem",
          marginBottom: "1rem"
        }}
      >
        <iframe
          src="/CloudGenomics_MSA.pdf"
          title="CloudGenomics MSA"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>

      <h3>Privacy Policy</h3>
      <div
        ref={privacyRef}
        style={{
          height: "300px",
          overflowY: "scroll",
          border: "1px solid #ccc",
          padding: "1rem",
          marginBottom: "1rem"
        }}
      >
        <iframe
          src="/CloudGenomics_Privacy_Policy.pdf"
          title="CloudGenomics Privacy Policy"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </div>

      <label>
        <input
          type="checkbox"
          disabled={!canAccept}
          checked={accepted}
          onChange={() => setAccepted(!accepted)}
        />
        I acknowledge that I have read and accept the CloudGenomics Terms.
      </label>

      <button disabled={!accepted} onClick={submit}>
        Continue
      </button>
    </div>
  );
}